import React from "react";

import newlogo from "../Images/White TCMO (1).svg";
import abcIT from "../Images/White ITSW (1).svg";
// import abcMartech from "../Images/footer logos/NewLogos/martech-logo.webp";
import abcFin from "../Images/White TFT (1).svg";
import abcEt from "../Images/White ET (2).svg";
import abcGov from "../Images/White TGT (1).svg";

const logos = [
  {
    link: "https://enterprisetalk.com/",
    src: abcEt,
    alt: "enterprisetalk",
    className: "imgET",
  },
  {
    link: "https://itsecuritywire.com/",
    src: abcIT,
    alt: "itsecurity",
    className: "imgPublicaCMO",
  },
  {
    link: "https://talkfintech.com/",
    src: abcFin,
    alt: "talkfintech",
    className: "imgPublica",
  },
  // {
  //   link: "https://talkmartech.com/",
  //   src: abcMartech,
  //   alt: "talkmartech",
  //   className: "imgPublica",
  // },
  {
    link: "https://talkcmo.com/",
    src: newlogo,
    alt: "talkcmo",
    className: "imgPublicaCMONew",
  },
  {
    link: "https://talkgovtech.com/",
    src: abcGov,
    alt: "talkgov",
    className: "imgPublicaGov",
  },
];

const FootLogoComp = () => {
  return (
    <div >
      {/* {logos.map((logo) => (
        <a
          key={logo.alt}
          href={logo.link}
          className="footer-grid-item"
          target="_blank"
          rel="noreferrer"
        >
          <img
            className={logo.className}
            src={logo.src}
            alt={logo.alt}
            loading="lazy"
          />
        </a>
      ))} */}

      
      <div className="d-flex flex-wrap align-items-center justify-content-center gap-3 gap-md-3">
  {logos.map((logo) => (
    <a
      key={logo.alt}
      href={logo.link}
      target="_blank"
      rel="noreferrer"
      className="d-flex align-items-center justify-content-center"
    >
      <img
        src={logo.src}
        alt={logo.alt}
        loading="lazy"
        className="img-fluid"
        style={{
          height: "30px",
          width: "auto",
          objectFit: "contain",
        }}
      />
    </a>
  ))}
</div>
    </div>
  );
};

export default FootLogoComp;